import React, { useState } from "react";
import SidebarAdmin from "./SidebarAdmin";
import AdminNavbar from "./AdminNavbar";
import PostAdminButton from "../Assets/PostAdminButton";
import ModalConfirmation from "../Assets/ModalConfirmation";
import AdminSearchBar from "../Assets/AdminSearchBar";
import { ContactInfo } from "../Types/Types";
import useContactInfo from "../Hooks/useContactInfo";
import ContactInfoModal from "./ContactInfoModal";
import AdminContactInfoTable from "./AdminContactInfoTable";
import ContactInfoEditModal from "./ContactInfoEditModal";
import { useTranslation } from "react-i18next";


interface AdminContactInfoProps {
    lang: string;
}

const AdminContactInfo: React.FC<AdminContactInfoProps> = ({ lang }) => {

    const { t } = useTranslation()

    const [modalOpen, setModalOpen] = useState(false);
    const [showForm, setShowForm] = useState(false); // Toggle form visibility
    const [selectedContactInfoId, setSelectedContactInfoId] = useState<string | null>(null);
    const [showEditForm, setShowEditForm] = useState(false);
    const [contactInfoToEdit, setContactInfoToEdit] = useState<ContactInfo | null>(null);


    const {
        contactInfos,
        loading,
        error,
        createContactInfo,
        searchQuery,
        setSearchQuery,
        setSortBy,
        setSortOrder,
        updateContactInfo,
        deleteContactInfo
    } = useContactInfo();

    const handleSearch = (query: string) => {
        setSearchQuery(query); // Update the search query state
    };

    // Deletion logic
    const handleDeleteRequest = (id: string) => {
        setSelectedContactInfoId(id);
        setModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (selectedContactInfoId) {
            await deleteContactInfo(selectedContactInfoId);
            setSelectedContactInfoId(null);
        }
        setModalOpen(false);
    };

    const handleDeleteCancel = () => {
        setSelectedContactInfoId(null);
        setModalOpen(false);
    };

    return (
        <div className="min-h-screen bg-gray-100 flex">
            {/* Sidebar */}
            <div className="w-64">
                <SidebarAdmin />
            </div>

            <div className="flex-1 flex flex-col">
                {/* Navbar */}
                <AdminNavbar />

                {/* Main Content */}
                <div className="flex-1 py-12 px-48 space-y-12">
                    <h1 className="text-4xl text-blue-900">
                        {t(`navbar.contacts`)}
                    </h1>
                    <div className="flex justify-between items-center space-x-4">
                        <PostAdminButton onClick={() => setShowForm(true)} />
                        <AdminSearchBar searchQuery={searchQuery} onSearch={handleSearch} />
                    </div>

                    <AdminContactInfoTable
                        contactInfos={contactInfos}
                        loading={loading}
                        error={error}
                        onDelete={handleDeleteRequest}
                        onEdit={(productData) => {
                            setContactInfoToEdit(productData);
                            setShowEditForm(true);
                        }}
                        onSortChange={(field, order) => {
                            setSortBy(field);
                            if (order === 'asc' || order === 'desc') {
                                setSortOrder(order);
                            }
                        }}
                        lang={lang}
                    />
                </div>
            </div>

            <ContactInfoModal
                isOpen={showForm}
                onClose={() => setShowForm(false)}
                onSubmit={async (contactInfo) => {
                    await createContactInfo(contactInfo.name, contactInfo.description, contactInfo.image);
                    setShowForm(false); // Close the modal after successful submission
                }}
            />
            {/* Edit Modal */}


            {showEditForm && contactInfoToEdit && (
                <ContactInfoEditModal
                    isOpen={showEditForm}
                    onClose={() => setShowEditForm(false)}
                    onSubmit={async (contactInfoId, updatedData) => {
                        await updateContactInfo(contactInfoId, updatedData);
                        setShowEditForm(false);
                        setContactInfoToEdit(null);
                    }}
                    initialData={contactInfoToEdit}
                    lang={lang}
                />
            )}





            {/* Deletion Confirmation Modal */}
            <ModalConfirmation
                isOpen={modalOpen}
                onClose={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
            />
        </div>
    );
};

export default AdminContactInfo;
